import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { getIconStyles as r } from "../styles.js";
const c = (e) => /* @__PURE__ */ i(
  "svg",
  {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_3922_20961)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.625 7C13.625 7.89746 12.8975 8.625 12 8.625C11.1025 8.625 10.375 7.89746 10.375 7C10.375 6.10254 11.1025 5.375 12 5.375C12.8975 5.375 13.625 6.10254 13.625 7ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12V16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5V12Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3922_20961", children: /* @__PURE__ */ l(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.0234375 -0.00012207)"
        }
      ) }) })
    ]
  }
);
export {
  c as SolidCircleInfoIcon
};
//# sourceMappingURL=SolidCircleInfoIcon.js.map
